import {Logo, LogoProps} from '../../components/ui/logo.js'
import {BoxProps, Center} from '@chakra-ui/react'

interface Props extends BoxProps {
  logoProps?: LogoProps
}

export function LoadingLogo({logoProps, ...props}: Props) {
  return (
    <Center width="100%" height="100%" overflow="hidden" {...props}>
      <Logo hideText size={72} animation="ping" {...logoProps} />
    </Center>
  )
}
